'use client'

import { SiteFooter } from '@/components/site-footer'
import { SiteHeader } from '@/components/site-header'
import { BreadcrumbJsonLd } from '@/components/seo/breadcrumb-jsonld'
import { toolBreadcrumbs } from '@/lib/breadcrumbs'
import type { QuizBucket } from '@/lib/homepage-2026/types'
import { QuizCard } from '@/components/homepage-2026/quiz'
import { SecFindYourFridgeCompactWorking } from '@/components/homepage-2026/canvas/sections'
import { HomeSprite } from '@/components/homepage-2026/canvas/sprite'

const TRAIL = toolBreadcrumbs({ name: 'Find Your Fridge' })

/** The tool and homepage share the same truthful questions, group selection and results. */
export function FindYourFridgePageClient({ buckets }: { buckets: QuizBucket[] }) {
  return <>
    <BreadcrumbJsonLd trail={TRAIL} id="tool-breadcrumb-jsonld" />
    <SiteHeader />
    <main id="main-content" className="hp26">
      <HomeSprite />
      <div className="wrap" style={{ paddingTop: 32 }}>
        <h1 style={{ fontSize: 'clamp(28px, 4vw, 48px)', fontWeight: 800, color: '#101828' }}>Find Your Fridge</h1>
      </div>
      <SecFindYourFridgeCompactWorking slots={{ 'quiz-card': <QuizCard buckets={buckets} /> }} L={href => href} />
    </main>
    <SiteFooter />
  </>
}
